import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function FinalCta() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">{t('final.title')}</h2>
        <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">{t('final.subtitle')}</p>
        <div className="mt-8">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-grid-line text-base"></i>
            {t('final.cta')}
          </a>
        </div>
      </div>
    </section>
  );
}